// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { xngSubmitEmailForms } from "@rc/App/Services/EmailForms/EmailFormsService";

type SubmitContactFormParameter = {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    company: string;
    industry: string;
    event: string;
    legalTerms: boolean;
    optIn: boolean;
    emailFormType: string;
} & HasOnSuccess &
    HasOnError;

export interface RcSubmitEmailFormsApiParameter extends SubmitContactFormParameter {}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, RcSubmitEmailFormsApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        firstName: props.parameter.firstName,
        lastName: props.parameter.lastName,
        emailAddress: props.parameter.emailAddress,
        phoneNumber: props.parameter.phoneNumber,
        company: props.parameter.company,
        industry: props.parameter.industry,
        event: props.parameter.event,
        legalTerms: props.parameter.legalTerms,
        optIn: props.parameter.optIn,
        emailFormType: props.parameter.emailFormType,
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        await xngSubmitEmailForms(props.apiParameter.emailFormType, props.apiParameter);
        props.parameter.onSuccess?.();
    } catch (error) {
        props.parameter.onError?.();
    }
};

export const chain = [PopulateApiParameter, SendDataToApi];

const submitEmailsForm = createHandlerChainRunner(chain, "SubmitEmailsForm");
export default submitEmailsForm;
